exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".BackToTopoverride__backtotop___3NBBu{margin-top:10px;text-align:right}", ""]);

// exports
exports.locals = {
	"backtotop": "BackToTopoverride__backtotop___3NBBu"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/client/components/PageInvestmentReasons/overrides/BackToTopoverride.pcss
// module id = 917
// module chunks = 0